"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const getOptions = module => {
  if (typeof window !== "undefined") {
    return {}; // We cannot modify User-Agent header in browser
  }
  const environment = process.env.IS_STAGING ? "staging" : "production";
  return {
    headers: {
      Accept: "application/json",
      "User-Agent": `frontend/${module} (Kiwi.com ${environment})`,
      "Content-Type": "application/json"
    }
  };
};
const getAll = function () {
  var _options$url;
  let {
    module = "search",
    options
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Promise.all([fetch(`${(_options$url = options === null || options === void 0 ? void 0 : options.url) !== null && _options$url !== void 0 ? _options$url : "https://finance-launchpad.skypicker.com"}/${module}`, getOptions(module)).then(res => res.json()).then(res => res.currencies.supported_currencies), fetch("https://rates-finance.skypicker.com/", getOptions(module)).then(res => res.json())]).then(_ref => {
    let [list, rates] = _ref;
    return list.map(entry => ({
      id: entry.code.toLowerCase(),
      name: entry.name,
      precision: entry.precision,
      fallback: "eur",
      enabledOnAffilId: entry.affil_id.length > 0 ? entry.affil_id : "",
      format: entry.format,
      uncertainFormat: false,
      rate: 1 / rates[entry.code.toUpperCase()].value
    })).reduce((acc, next) => ({
      ...acc,
      [next.id]: next
    }), {});
  });
};
var _default = exports.default = getAll;